import { useTranslation } from "react-i18next";
import { Spinner } from "./Spinner";
import styles from "./States.module.css";

/**
 * The shared "loading" state. Every screen that waits on a network request renders this rather
 * than inventing its own spinner, so loading looks and behaves the same everywhere in the portal.
 *
 * @param props.label - Text announced to assistive technology and shown alongside the spinner.
 *   Defaults to a generic "Loading…".
 */
export function LoadingState({ label }: { label?: string }): React.JSX.Element {
  const { t } = useTranslation();
  const text = label ?? t("states.loading.default");

  return (
    <div className={styles.loading} role="status">
      <Spinner />
      <span>{text}</span>
    </div>
  );
}
